import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { cloneDeep } from 'lodash'

import Loader from '../../Loader'
import { DataTableFiltered } from './../../DataTable'

import CommonRulesToolbar from './../Common/CommonRulesToolbar'

import MerchantCategoryActionsCell from './MerchantCategoryActionsCell'
import MerchantCategoryRuleModal from './Modals/MerchantCategoryRuleModal'

import { MerchantCategoryRulesActions } from './../actions'

import COMMON_COLUMNS from './../Common/commonColumns'
import { STORE_PATH } from './../constants'

class RulesMerchantCategory extends Component {
  constructor(props) {
    super(props)

    this.columns = this.getColumns(cloneDeep(COMMON_COLUMNS))
  }

  getColumns(commonColumns) {
    const columns = [
      commonColumns.id,
      commonColumns.merchantId,
      commonColumns.merchantName,
      commonColumns.categoryId,
      commonColumns.categoryFullPath,
      commonColumns.categoryIsLeaf,
      commonColumns.updatedAt,
      commonColumns.updatedByName,
      commonColumns.isActive,
      {
        ...commonColumns.actionsColumn,
        dataFormat: (cell, row) => <MerchantCategoryActionsCell row={row} />
      }
    ]

    return columns
  }

  render() {
    const {
      loading,
      pageSize,
      hasEditAccess,
      totalCount,
      page,
      rows,
      sortBy,
      sortOrder,
      filters,
      fetchRulesAction,
      downloadRulesAction,
      clearFilters,
      saveRuleAction
    } = this.props

    return (
      <React.Fragment>
        <CommonRulesToolbar
          hasEditAccess={hasEditAccess}
          toolbarType={'Merchant Category'}
          createRuleModalContet={<MerchantCategoryRuleModal onOkHandler={saveRuleAction} />}
          downloadRulesAction={downloadRulesAction}
          refreshHandler={fetchRulesAction}
          clearFilters={clearFilters}
        />

        {loading && <Loader loading overlap />}

        <DataTableFiltered
          data={rows}
          columns={this.columns}
          page={page}
          pageSize={pageSize}
          totalCount={totalCount}
          sortBy={sortBy}
          sortOrder={sortOrder}
          filters={filters}
          tableClassName="rules-table"
          fetchRowsAction={fetchRulesAction}
        />
      </React.Fragment>
    )
  }
}

RulesMerchantCategory.defaultProps = {
  rows: [],
  totalCount: 0
}

RulesMerchantCategory.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  sortBy: PropTypes.string,
  sortOrder: PropTypes.string,
  filters: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  hasEditAccess: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchRulesAction: PropTypes.func.isRequired,
  downloadRulesAction: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  saveRuleAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ rules: { [STORE_PATH.merchantCategory]: merchantCategory } }) => ({
  page: merchantCategory.page,
  sortBy: merchantCategory.sortBy,
  loading: merchantCategory.loading,
  rows: merchantCategory.data.rows,
  pageSize: merchantCategory.pageSize,
  sortOrder: merchantCategory.sortOrder,
  totalCount: merchantCategory.data.count,
  filters: merchantCategory.filters
})

const mapDispatchToProps = {
  fetchRulesAction: MerchantCategoryRulesActions.fetch,
  downloadRulesAction: MerchantCategoryRulesActions.download,
  clearFilters: MerchantCategoryRulesActions.clearFilters,
  saveRuleAction: MerchantCategoryRulesActions.save
}

export default connect(mapStateToProps, mapDispatchToProps)(RulesMerchantCategory)
